/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Contact_Sales_TitleInputs */

const en_platform_contact_sales_title = /** @type {(inputs: Platform_Contact_Sales_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you sign up`)
};

const pl_platform_contact_sales_title = /** @type {(inputs: Platform_Contact_Sales_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zanim się zarejestrujesz`)
};

/**
* | output |
* | --- |
* | "Before you sign up" |
*
* @param {Platform_Contact_Sales_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_sales_title = /** @type {((inputs?: Platform_Contact_Sales_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_Sales_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_sales_title(inputs)
	return en_platform_contact_sales_title(inputs)
});